export enum TransactionalTypes {
  Only,
  Programmatic,
  Connect,
}
